import React, { useContext, useState, useRef, useEffect } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  getSystemSettings,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Moment from "react-moment";
import { useReactToPrint } from "react-to-print";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import { MdDelete } from 'react-icons/md';
// import StockReport from "./StockReport";

//pages & includes
import AccountsSidebar from "../AccountsSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const SalesFlowReport = () => {
  const { t } = useTranslation();
  let { loading, setLoading, generalSettings } = useContext(SettingsContext);
  const { branchForSearch } = useContext(RestaurantContext);
  const { authUserInfo } = useContext(UserContext);

  //toast obj
  let common_toast = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  //reportFields state
  const [option, setOption] = useState("print");
  const [balanceSheetView, setBalanceSheetView] = useState(null);
  const [searchBalanceSheetView, setSearchBalanceSheetView] = useState({
    searched: false,
    list: [],
  });
  const [reportFields, setReportFields] = useState({
    from_date: "",
    to_date: "",
    branch: "",
    type:"closing",
    option: "detail"
  });

  const [siteName, setSiteName] = useState("");
  //report states
  const [reportData, setReportData] = useState([]);
  const [generatedReport, setGeneratedReport] = useState(false);

  const componentRef = useRef();
  const componentRefThermal = useRef();

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
  }, [generalSettings]);

  //search account here
  // const handleSearch = (e) => {
  //   let searchInput = e.target.value.toLowerCase();
  //   if (searchInput.length === 0) {
  //     setBalanceSheetView({ ...searchBalanceSheetView, searched: false });
  //   } else {
  //     let searchedList = balanceSheetView?.data && balanceSheetView.data.filter((item) => {
  //       let lowerCaseItemIdentity = item.DocumentIdentity && item.DocumentIdentity.toLowerCase();
  //       let lowerCaseItemAccount = item.AccountName.toLowerCase();
  //       let lowerCaseItemCheque = item.ChequeNo && item.ChequeNo.toLowerCase();
  //       return (lowerCaseItemIdentity && lowerCaseItemIdentity.includes(searchInput)) ||
  //       (lowerCaseItemAccount && lowerCaseItemAccount.includes(searchInput)) ||
  //       (lowerCaseItemCheque && lowerCaseItemCheque.includes(searchInput));
  //     });
  //     setSearchBalanceSheetView({
  //       list: searchBalanceSheetView,
  //       searched: true,
  //     });
  //   }
  // };

  // const handleFromDate=(from_date)=>{
  //   setReportFields({
  //     ...reportFields,
  //     from_date
  //   })
  // }

  const handleToDate = (key,value) => {
    setReportFields({
      ...reportFields,
      [key]: value,
    });
  };

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  const handleBranch = (branch) => {
    setReportFields({
      ...reportFields,
      branch,
    });
  };

  const handleSetType = (e)=>{
    setReportFields({
      ...reportFields,
      type: e.target.value
    })
  }

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `@page { margin: 10px 15px; }`,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setBalanceSheetView(null);
    setSearchBalanceSheetView(null);
    setGeneratedReport(false);
    let { from_date, to_date, branch } = reportFields;
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !branch?.id
    ) {
      toast.error(`${_t(t("Please select branch"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }
    if (
      (from_date !== "" && from_date !== null) && to_date
    ) {
      // setLoading(true);
      // if (option === "view") {
      //   paginatedBalanceSheet(1);
      // } else {
        const endpoint = reportFields.type === "detail" ? "/settings/sales-flow-report" : "/settings/cash-flow-report"
        const url = BASE_URL + endpoint;
        let formData = new FormData();
        formData.append('from_date', moment(from_date).format("YYYY-MM-DD"));
        formData.append("to_date", moment(to_date).format("YYYY-MM-DD"));
        formData.append("branch_id", branch ? branch.id : "");
        formData.append("branch_name", branch ? branch.name : "");
        formData.append("type", reportFields.option);
        // if(reportFields.type !== "detail"){
        // }
        return axios
          .post(url, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then((res) => {
            setReportData(res.data.data);
            if (option === "print") {
              thermalPrint();
            } else {
              setGeneratedReport(true);
              componentRef.current.handleDownload();
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            toast.error(`${_t(t("Please try again"))}`, common_toast);
          });
      // }
    } else {
      toast.error(`${_t(t("Please select date"))}`, common_toast);
    }
  };

  let totalInFlow = 0;
  let totalOutFlow = 0;
  let opening = 0;

  const sumAmounts = (arr) =>
  arr.reduce((total, item) => total + parseFloat(item.amount || 0), 0);
  const calculateTotal = (data) =>{
    return Object.keys(data).length > 0 && Object.values(data).reduce(
      (acc, group) => acc + sumAmounts(group),
      0
    );
  }
  const tableData = (data, type="print") => {
    if (data) {
      if(type === "print"){
        if(Array.isArray(data)){
          if(data?.length){
            return (
              <>  
                {data.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="pl-4 text-capitalize align-middle border-1 border ">{item.level3_name}</td>
                      {/* <td className="text-capitalize align-middle border-1 border ">{item.name}</td> */}
                      <td className="text-capitalize align-middle border-1 border ">{formatPrice(item.amount)}</td>
                    </tr>
                  );
                })}
              </>
            )
          }
        }else{
          return (
            <>
              {Object.keys(data).map((item, index) => {
                let groupTotal = 0;
                if (Array.isArray(data[item])) {
                  groupTotal = sumAmounts(data[item]);
                }
                return (
                  <>
                    <tr key={index}>
                      <th style={{fontSize: "0.77rem"}} className="pl-3 text-capitalize align-middle border-1 border ">{item}</th>
                      <td className="text-capitalize align-middle border-1 border " colSpan={1}></td>
                    </tr>
                    {tableData(data[item])}
                    {Array.isArray(data[item]) && (
                      <tr>
                        <th style={{fontSize: "0.77rem"}} className="pl-3 text-capitalize align-middle border-1 border">{item} Total</th>
                        <th style={{fontSize: "0.77rem"}} className="text-capitalize align-middle border-1 border">{formatPrice(groupTotal)}</th>
                      </tr>
                    )}
                  </>
                );
              })}
            </>
          )
        }
      }else{
        if(Array.isArray(data)){
          if(data?.length){
            return (
              <>  
                {data.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td></td>
                      <td>{item.level3_name}</td>
                      {/* <td>{item.name}</td> */}
                      <td>{formatPrice(item.amount)}</td>
                    </tr>
                  );
                })}
              </>
            )
          }
        }else{
          return (
            <>
              {Object.keys(data).map((item, index) => {
                // if(!Array.isArray(data[item]) && typeof data[item] !== "object" && item==="Total Outflow"){
                //   totalOutFlow = Number(data[item]);
                // }
                // if(!Array.isArray(data[item]) && typeof data[item] !== "object" && item==="Total Inflow"){
                //   totalInFlow = Number(data[item]);
                // }
                let groupTotal = 0;
                if (Array.isArray(data[item])) {
                  groupTotal = sumAmounts(data[item]);
                }
                return (
                  <>
                    <tr key={index}>
                      {
                        // !Array.isArray(data[item]) && typeof data[item] !== "object" ? (
                        //   <>  
                        //     <th></th>
                        //     <th>{item}</th>
                        //     {/* <th></th> */}
                        //     <th>{formatPrice(data[item]) ?? ""}</th>
                        //   </>
                        // ) : 
                      }
                      <th>{item}</th>
                    </tr>
                    {/* {!Array.isArray(data[item]) && typeof data[item] !== "object" && <tr></tr>} */}
                    {tableData(data[item], "download")}
                    {Array.isArray(data[item]) && (
                      <>
                        <tr>
                          <th></th>
                          <th>{item} Total</th>
                          <th>{formatPrice(groupTotal)}</th>
                        </tr>
                      </>
                    )}
                  </>
                );
              })}
            </>
          )
        }
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Cash Flow Report"))}</title>
      </Helmet>

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename={`Cash Flow ${reportFields.type === "detail" ? "Detail" : (reportFields.option === "detail" ? "Closing Detail" : "Closing Summary")}`}
        sheet="sheet 1"
        buttonText="Report"
        ref={componentRef}
      />

      {/* Print Button */}
      <div className="d-none">
        <div className="fk-print">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {reportData !== null &&
                  reportData !== undefined &&
                  generatedReport === true && (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="table-to-xls"
                          >
                            <div className="page-break"></div>
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="3" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Cash Flow {reportFields.type === "detail" ? "Detail" : (reportFields.option === "detail" ? "Closing Detail" : "Closing Summary")} Report
                                      </h3>
                                      {/* <p className="text-center">
                                        {reportData?.branch?.name ?? ""}
                                      </p> */}
                                      <p className="text-center">
                                        From&nbsp;
                                        <Moment format="LL">
                                          {reportFields.from_date}
                                        </Moment>
                                        &nbsp;To&nbsp;
                                        <Moment format="LL">
                                          {reportFields.to_date}
                                        </Moment>
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here*/}
                              {Object.keys(reportData).map((item, index) => {
                                return (
                                  <>
                                    <tr key={index}>
                                      <th colSpan={3}>{item}</th>
                                    </tr>
                                    <tr></tr>
                                    <tr>
                                      <td></td>
                                      <th>Account</th>
                                      {/* <th>Branch</th> */}
                                      <th>Amount</th>
                                    </tr>
                                    {
                                      Object.keys(reportData[item]).map((item2) => {
                                        if(Array.isArray(reportData[item][item2]) && item2==="Opening Cash"){
                                          opening = reportData[item][item2][0]?.amount
                                        }
                                        if(!Array.isArray(reportData[item][item2]) && item2==="Inflows"){
                                          totalInFlow = calculateTotal(reportData[item][item2]);
                                        }
                                        if(!Array.isArray(reportData[item][item2]) && item2==="Outflows"){
                                          totalOutFlow = calculateTotal(reportData[item][item2]);
                                        }
                                        return (
                                          <>
                                            <tr>
                                              <th className="table-text"><strong>{item2}</strong></th>
                                            </tr>
                                            {tableData(reportData[item][item2], "download")}
                                            {(item2 === "Outflows" || item2 === "Inflows") && (
                                              <tr>
                                                <th></th>
                                                <th>{item2} Total</th>
                                                {/* <th></th> */}
                                                <th>{formatPrice(item2 === "Inflows" ? totalInFlow : totalOutFlow)}</th>
                                              </tr>
                                            )}
                                            {
                                              item2 === "Inflows" && (
                                                <tr>
                                                  <th></th>
                                                  <th>Total After Opening</th>
                                                  {/* <th></th> */}
                                                  <th>{formatPrice(opening + totalInFlow)}</th>
                                                </tr>
                                              )
                                            }
                                            <tr></tr>
                                          </>
                                        );
                                      })
                                    }
                                  </>
                                );
                              })}
                              {/* {tableData(reportData,"download")} */}
                              <tr>
                                <th></th>
                                <th>Cash in Hand</th>
                                {/* <th></th> */}
                                <th>{formatPrice(opening + totalInFlow - totalOutFlow)}</th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* thermal print */}
      <div className="d-none">
        <div ref={componentRefThermal}>
          {
            <div className="fk-print">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    {reportData !== null && reportData !== undefined && (
                      <table className="table table-bordered mt-4 fk-print-text_pos">
                        <thead className="align-middle sm-text">
                          <tr style={{ border: "0px" }}>
                            <th colspan="3" style={{ border: "0px" }}>
                              <div className="row">
                                <h3 className="text-center mb-0">{siteName}</h3>
                                <h3 className="mt-2 font-weight-bold text-uppercase text-center table-text">
                                  Cash Flow {reportFields.type === "detail" ? "Detail" : (reportFields.option === "detail" ? "Closing Detail" : "Closing Summary")} Report
                                </h3>
                                <p className="mt-1 mb-0 font-weight-bold text-uppercase text-center table-text">
                                  {reportData?.branch?.name ?? ""}
                                </p>
                                <div>
                                  <p className="mt-1 mb-0 font-weight-bold text-uppercase text-center table-text">
                                    {/* FROM&nbsp;
                                    <Moment format="LL">
                                    {reportFields.from_date}
                                    </Moment> */}
                                    From &nbsp;
                                    <Moment format="LL">
                                      {reportFields.from_date}
                                    </Moment>
                                    &nbsp;to&nbsp;
                                    <Moment format="LL">
                                      {reportFields.to_date}
                                    </Moment>
                                    
                                  </p>
                                </div>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="align-middle sm-text">
                          {Object.keys(reportData).map((item, index) => {
                            return (
                              <>
                                <tr key={index}>
                                  <th style={{fontSize: "0.77rem"}} className="text-capitalize align-middle text-center" colSpan={2}>{item}</th>
                                </tr>
                                <tr style={{height:"20px"}}></tr>
                                <tr>
                                  <th style={{fontSize: "0.77rem"}} className="text-capitalize align-middle border-1 border ">Account</th>
                                  {/* <th className="text-capitalize align-middle border-1 border ">Branch</th> */}
                                  <th style={{fontSize: "0.77rem"}} className="text-capitalize align-middle border-1 border ">Amount</th>
                                </tr>
                                {
                                  Object.keys(reportData[item]).map((item2) => {
                                    if(Array.isArray(reportData[item][item2]) && item2==="Opening Cash"){
                                      opening = reportData[item][item2][0]?.amount
                                    }
                                    if(!Array.isArray(reportData[item][item2]) && item2==="Inflows"){
                                      totalInFlow = calculateTotal(reportData[item][item2]);
                                    }
                                    if(!Array.isArray(reportData[item][item2]) && item2==="Outflows"){
                                      totalOutFlow = calculateTotal(reportData[item][item2]);
                                    }
                                    return (
                                      <>
                                        <tr>
                                          <th className="table-text font-weight-bold align-middle border-1 border ">{item2}</th>
                                          <td className="align-middle border-1 border " colSpan={1}></td>
                                        </tr>
                                        {tableData(reportData[item][item2])}
                                        {
                                          (item2 === "Outflows" || item2 === "Inflows") && (
                                            <tr>
                                              <th className="table-text"><strong>{item2} Total</strong></th>
                                                {/* <th></th> */}
                                              <th className="table-text"><strong>{formatPrice(item2 === "Inflows" ? totalInFlow : totalOutFlow)}</strong></th>
                                            </tr>
                                          )
                                        }
                                        {
                                          item2 === "Inflows" && (
                                            <tr>
                                              <th className="table-text"><strong>Total After Opening</strong></th>
                                                {/* <th></th> */}
                                              <th className="table-text"><strong>{formatPrice(opening + totalInFlow)}</strong></th>
                                            </tr>
                                          ) 
                                        }
                                      </>
                                    );
                                  })
                                }
                                {/* {tableData(reportData[item])} */}
                              </>
                            );
                          })}
                          <tr>
                            <th className="table-text"><strong>Cash in Hand</strong></th>
                            {/* <th></th> */}
                            <th className="table-text"><strong>{formatPrice(opening + totalInFlow - totalOutFlow)}</strong></th>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <AccountsSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading} />
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {/* {loading === true ? (
                      tableLoading()
                    ) : ( */}
                    <div key="fragment-3">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Cash Flow Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7 d-flex justify-content-end">
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <div className="d-inline mr-2 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="print_report"
                                name="print_report"
                                value="print"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={option === "print"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="print_report"
                                style={{
                                  fontSize: "16px",
                                  borderRadius: "5px",
                                }}
                              >
                                <i class="fa fa-print" aria-hidden="true"></i>{" "}
                                {_t(t("Print"))}
                              </label>
                            </div>
                          </div>
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="excel_report"
                              name="excel_report"
                              value="excel"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={option === "excel"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                              htmlFor="excel_report"
                              style={{ fontSize: "16px", borderRadius: "5px" }}
                            >
                              <i class="fa fa-table" aria-hidden="true"></i>{" "}
                              {_t(t("Excel"))}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="card px-2 mx-1">
                        {/* Form starts here */}
                        <form
                          className="row p-1 mx-0 mb-5 table-text"
                          onSubmit={handleSubmit}
                        >
                          <div className="col-12">
                            <div>
                              <div className="row">
                                <div className="form-group col-2 text-right mt-2">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="fromDate"
                                      className="control-label"
                                    >
                                      {_t(t("From Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      selected={reportFields.from_date}
                                      onChange={(date) => handleToDate("from_date",date)}
                                      maxDate={new Date()}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("From Date"))}
                                      shouldCloseOnSelect={false}                                  
                                    />
                                  </div>
                                </div>

                                <div className="form-group col-2 text-right mt-2">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="toDate"
                                      className="control-label"
                                    >
                                      {_t(t("To Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <DatePicker
                                    selected={reportFields.to_date}
                                    onChange={(date) => handleToDate("to_date",date)}
                                    maxDate={new Date()}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control table-text d-block"
                                    placeholderText={_t(t("Date"))}
                                    shouldCloseOnSelect={false}
                                  />
                                </div>

                                <div className="form-group mt-2 col-3">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="transaction"
                                      className="control-label"
                                    >
                                      {_t(t("Branch"))}
                                    </label>
                                  </div>
                                  <Select
                                    options={
                                      branchForSearch ? branchForSearch : []
                                    }
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={reportFields.branch || ""}
                                    classNamePrefix="select table-text"
                                    onChange={(branch) => handleBranch(branch)}
                                    isClearable
                                    placeholder={
                                      _t(t("Please select branch")) + ".."
                                    }
                                    styles={customStyle}
                                  />
                                </div>

                                <div className="col-2 mt-2">
                                  <div className="mt-3">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="closing"
                                      name="closing"
                                      value="closing"
                                      onChange={(e) => handleSetType(e)}
                                      checked={reportFields.type === "closing"}
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2"
                                      htmlFor="closing"
                                    >
                                      {_t(t("Closing"))}
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="detail"
                                      name="detail"
                                      value="detail"
                                      onChange={(e) => handleSetType(e)}
                                      checked={reportFields.type === "detail"}
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2"
                                      htmlFor="detail"
                                    >
                                      {_t(t("Detail"))}
                                    </label>
                                  </div>
                                </div>

                                <div className="col-3 mt-2">
                                  <div className="mt-3">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="detail_12"
                                      name="detail"
                                      value="detail"
                                      onChange={(e) => handleToDate("option", e.target.value)}
                                      checked={reportFields.option === "detail"}
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2"
                                      htmlFor="detail_12"
                                    >
                                      {_t(t("Detail"))}
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="summary"
                                      name="summary"
                                      value="summary"
                                      onChange={(e) => handleToDate("option", e.target.value)}
                                      checked={reportFields.option === "summary"}
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2"
                                      htmlFor="summary"
                                    >
                                      {_t(t("Summary"))}
                                    </label>
                                  </div>
                                </div>
                                <div className="col-10 mt-3"></div>

                                <div className="form-group mt-3 col-2 text-right">
                                  <button
                                    disabled={loading}
                                    type="submit"
                                    className="btn btn-primary rounded mt-2"
                                  >
                                    <i
                                      className="fa fa-table"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {_t(t("Print Sheet"))}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default SalesFlowReport;
